import { writable } from 'svelte/store'

export interface Toast {
  id: number
  kind: 'error' | 'success' | 'info'
  message: string
}

export const toasts = writable<Toast[]>([])

let nextId = 1

export function pushToast(kind: Toast['kind'], message: string, autoDismissMs = 5000): void {
  const id = nextId++
  toasts.update(($t) => [...$t, { id, kind, message }])
  if (autoDismissMs > 0) {
    setTimeout(() => {
      toasts.update(($t) => $t.filter((t) => t.id !== id))
    }, autoDismissMs)
  }
}

export function dismissToast(id: number): void {
  toasts.update(($t) => $t.filter((t) => t.id !== id))
}
